module.exports = __webpack_public_path__ + "static/media/boekenweek-onder-de-vlinderboom-min.728662fa.png";